/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ErrorService } from '@rma/generic/fallback-pages';
import { catchError } from 'rxjs/operators';
import { BlogService } from '../data-access-blog/blog.service';
import { BlogPost } from '../domain';

export const blogPostResolver = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const blogService = inject(BlogService);
  const error = inject(ErrorService);
  const slug = route.paramMap.get('slug')?.trim();

  if (!slug || slug === '') {
    const e = new HttpErrorResponse({ error: new Error('No post slug code passed'), status: 404 });
    return error.handleError<BlogPost>(state.url, e);
  }

  return blogService.getPost(slug).pipe(catchError((e) => error.handleError<BlogPost>(state.url, e)));
};
